import React from 'react';
import { useHistory } from 'react-router-dom';
import { filter } from 'lodash/fp';
import { useTranslation } from 'react-i18next';
import CategoryForm from '../CategoryForm';
import { useMutation } from '../../../../../graphql/hooks';
import { GET_CATEGORIES, GET_CATEGORY_FORM_DATA, REMOVE_CATEGORY, UPDATE_CATEGORY } from '../../../graphql';
import { OnSubmit } from '../types';
import Query from '../../../../../graphql/Query';
import { Category } from '../../../../../server-types';
import { EditFormLayout } from '../../../../../ui-kit';
import { routePaths } from '../../../../../routePaths';
import { UpdateCategoryFormQueryProps, UpdateCategoryProps } from './types';


const CreateCategoryForm = ({ categoryId }: UpdateCategoryProps) => {
    const history = useHistory();
    const { t } = useTranslation();
    const [updateCategory, { loading }] = useMutation(UPDATE_CATEGORY);
    const [remove] = useMutation(
        REMOVE_CATEGORY,
        { refetchQueries: [{ query: GET_CATEGORIES }] }
    );

    const onSubmit: OnSubmit = async ({ parentCategoryId, ...values }) => {
        const finalParentCategoryId = parentCategoryId === 'null' ? null : parentCategoryId;
        const variables = { id: categoryId, parentCategoryId: finalParentCategoryId, ...values };
        try {
            await updateCategory({ variables });
            history.push(routePaths.categories);
        } catch (error) {
            // nothing we can do
        }
    };


    const onRemove = async () => {
        try {
            await remove({ variables: { id: categoryId } });
            history.push(routePaths.categories);
        } catch (error) {
            // nothing we can do
        }
    };
    return (
        <Query<UpdateCategoryFormQueryProps> query={GET_CATEGORY_FORM_DATA} variables={{ id: categoryId }}>
            {({ data: { categories, category } }) => {
                const { category: parentCategory, description, name, color } = category;
                const initialValues = {
                    name,
                    parentCategoryId: parentCategory ? parentCategory.id : '',
                    description: description || '',
                    color
                };
                const filteredCategories = categories ?
                    filter((cat: Category) => cat.id !== categoryId)(categories) : [];
                return (
                    <EditFormLayout
                        onRemove={onRemove}
                        title={t('Update Category')}
                        buttonText={t('Remove Category')}
                    >
                        <CategoryForm
                            categories={filteredCategories}
                            initialValues={initialValues}
                            submitText={t('Update')}
                            onSubmit={onSubmit}
                            isLoading={loading}
                        />
                    </EditFormLayout>
                );
            }}
        </Query>
    );
};

export default CreateCategoryForm;
